export const loadPosts = async () => { 
  const postResponse = fetch('https://jsonplaceholder.typicode.com/posts')
  const photosResponse = fetch('https://jsonplaceholder.typicode.com/photos')
  const [posts,photos] = await Promise.all([postResponse,photosResponse])
  const postsJson = await posts.json();
  const photosJson = await photos.json();
  //unindo as postagens com as fotos, no caso o index vai fazer o pareamento já que temos mais fotos do que posts
  const postsAndPhotos = postsJson.map((post,index) =>{ 
    return{...post, cover:photosJson[index].url} //...post pega todos os posts e junta num array só. photosJson[index].url pega a url da foto a partir da sua posicao no array 
  });
  return postsAndPhotos
}